import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';
import { Login } from '../../../../interfaces/auth.interface';
import { Validation } from '../../../../interfaces/common';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import Link from '../../../../components/Link';

interface FormProps {
  formData: Login;
  validation: Validation;
  loading: boolean;
  onInputChange: (event: any, name: string) => void;
  onInputBlur: (event: any, name: string) => void;
  onSubmit: (event?: React.FormEvent) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  onForgotPassword?: () => void;
}

const Form: React.FC<FormProps> = ({ 
  formData, 
  validation, 
  loading,
  onInputChange, 
  onInputBlur, 
  onSubmit, 
  onKeyDown,
  onForgotPassword,
}) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <form id="formAuthentication" className="mb-5" autoComplete="off" onSubmit={onSubmit}>
      <div className="form-floating form-floating-outline mb-5">
        <Input
          type="tel"
          id={VALIDATION_FIELD_MAPPING.phoneNumber}
          name={VALIDATION_FIELD_MAPPING.phoneNumber}
          error={
            !!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.phoneNumber)
          }
          errorMessage={
            validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.phoneNumber)
              ?.message ?? ''
          }
          label={t('login.pageTexts.form.phoneNumber.label')}
          placeholder={t('login.pageTexts.form.phoneNumber.placeholder')}
          value={formData.phoneNumber}
          onKeyDown={onKeyDown}
          onBlur={onInputBlur}
          onChange={(e, name) => {
            if (!loading && /^[+]?[0-9]*$/.test(e.target.value)) {
              onInputChange(e, name);
            }
          }}
          autoComplete="tel"
          readOnly={loading}
        />
      </div>
      {/* <div className="mb-5">
        <div className="form-password-toggle">
          <div className="input-group input-group-merge">
            <div className="form-floating form-floating-outline">
              <Input
                type={showPassword ? 'text' : 'password'}
                id={VALIDATION_FIELD_MAPPING.password}
                name={VALIDATION_FIELD_MAPPING.password}
                error={
                  !!validation.fields.find(
                    (field) => field.field === VALIDATION_FIELD_MAPPING.password
                  )
                }
                errorMessage={
                  validation.fields.find(
                    (field) => field.field === VALIDATION_FIELD_MAPPING.password
                  )?.message ?? ''
                }
                label={t('login.pageTexts.form.password.label')}
                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                value={formData.password}
                onKeyDown={onKeyDown}
                onBlur={onInputBlur}
                onChange={onInputChange}
              />
            </div>
            <span
              className="password-eye-icon input-group-text cursor-pointer"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <i className={showPassword ? 'ri-eye-line' : 'ri-eye-off-line'}></i>
            </span>
          </div>
        </div>
      </div> */}
      <Button
        className="btn btn-primary d-grid w-100"
        text={t('login.pageTexts.form.signInButton')}
        disabled={loading}
        loading={loading}
        onClick={onSubmit}
      />
    </form>
  );
};

export default Form;
